
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-wallet/mobile/how-to-use-the-advanced-mode-in-komodo-wallet",
      function () {
        return require("private-next-pages/en/docs/komodo-wallet/mobile/how-to-use-the-advanced-mode-in-komodo-wallet/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-wallet/mobile/how-to-use-the-advanced-mode-in-komodo-wallet"])
      });
    }
  